export default __webpack_public_path__ + "static/media/no-messages.1be760c2.svg";